import { required } from 'vuelidate/lib/validators'

const formData = {
  id: {
    size: 4,
    type: 'hidden',
    name: 'id',
    classes: ['prices__form-field--hidden'],
    value: null
  },
  medicalService: {
    size: 4,
    type: 'search',
    name: 'medicalService',
    placeholder: 'Busque pelo nome',
    label: 'Nome',
    classes: ['prices__form-field prices__form-field--70'],
    value: null,
    endpoint: 'medical_service',
    format: '{$name}',
    returnFormat: 'object',
    fields: ['filterLike[ms.name]'],
    editedValue: null
  },
  price: {
    size: 4,
    type: 'currency',
    name: 'price',
    mask: '#####',
    placeholder: 'Digite o preço',
    label: 'Preço',
    classes: ['prices__form-field prices__form-field--30'],
    value: {
      converted: null,
      raw: 0
    }
  }
}

const validations = {
  price: {
    value: {
      required,
      isNotNull (value) {
        return ('converted' in value) ? (!!value.converted) : false
      }
    }
  }
}

export { formData, validations }
